/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiSaleBodyDataItemsItemDiscountType =
    (typeof PostApiSaleBodyDataItemsItemDiscountType)[keyof typeof PostApiSaleBodyDataItemsItemDiscountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiSaleBodyDataItemsItemDiscountType = {
    AMOUNT: 'AMOUNT',
    PERCENTAGE: 'PERCENTAGE',
    VARIABLE_AMOUNT: 'VARIABLE_AMOUNT',
    VARIABLE_PERCENTAGE: 'VARIABLE_PERCENTAGE',
} as const;
